import { render, staticRenderFns } from "./AgreementView.vue?vue&type=template&id=56dee0ee&scoped=true&"
import script from "./AgreementView.vue?vue&type=script&lang=js&"
export * from "./AgreementView.vue?vue&type=script&lang=js&"
import style0 from "./AgreementView.vue?vue&type=style&index=0&id=56dee0ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dee0ee",
  null
  
)

/* custom blocks */
import block0 from "./AgreementView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports